import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8f316ae0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "skeleton-block"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sk-loanList-header-bg"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li"), /*#__PURE__*/_createElementVNode("li"), /*#__PURE__*/_createElementVNode("li"), /*#__PURE__*/_createElementVNode("li"), /*#__PURE__*/_createElementVNode("li")], -1));

const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
}